module.exports = __webpack_public_path__ + "img/overlay-sign-bg.0e349c53.png";